import React from 'react';
import photo from '@sass/images/signup/photo.jpg';
import Page from '@components/Pages/Page';
import SignUp from './SignUp';

const SignUpPage = () => {
  return (
    <Page
      title="Sign Up Form"
      breadcrumbs={['Sign Up']}
      navPhoto={{ image: photo }}
      rightSidebar
      divider
    >
      <SignUp />
    </Page>
  )
}

export default SignUpPage;
